__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "open_oed";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@plurall/elo-beta", "2.0.0-beta.523", () => (Promise.all([__webpack_require__.e(646), __webpack_require__.e(829), __webpack_require__.e(272), __webpack_require__.e(439), __webpack_require__.e(116)]).then(() => (() => (__webpack_require__(75852))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(697).then(() => (() => (__webpack_require__(45697))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(829)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(818), __webpack_require__.e(829), __webpack_require__.e(272)]).then(() => (() => (__webpack_require__(49818))))));
			register("react", "18.3.1", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(67294))))));
			initExternal(19721);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};